import { error } from 'loglevel';
import { NotificationPreference } from 'src/types';
import api from 'src/utils/api';

const handleError = (ex: Error) => {
  error(ex);
  return null;
};

type ReturnType = Promise<NotificationPreference[] | null>;

export const fetchEmailPreferences = async (api: any, token?: string, userId?: number): ReturnType => {
  let response = null;
  if (token) {
    response = await api.getPublic(`email-notifications?unsubscribe-key=${token}`).catch(handleError);
  } else if (userId) {
    response = await api.get(`private/email-notifications?user-id=${userId}`).catch(handleError);
  }
  if (response?.status === 200) {
    return response?.data;
  }
  return null
};

export const updateEmailPreferences = async (notificationPreferences: NotificationPreference[], token?: string, userId?: number): ReturnType => {
  let response = null;
  if (token) {
    response = await api.putPublic(`email-notifications?unsubscribe-key=${token}`, {
      notificationPreferences,
    }).catch(handleError);
  } else if (userId) {
    response = await api.put('private/email-notifications', {
      userId,
      notificationPreferences,
    }).catch(handleError);
  }
  if (response?.status === 200) {
    return response?.data?.updatedPreferences;
  }
  return null;
};

